import { Component, Host, h, Element } from '@stencil/core';
import { observeElementVisibility } from '@aha-app/aha-shared';

export interface AhaLoadingDots extends HTMLAhaLoadingDotsElement {}

/**
 * A component which shows three loading dots.
 *
 * The color of the dots, as well as the size of the dots, inherits from the current text color/size, meaning that it should look correctly when used next to any text without any tweaking, and, if you _do_ want to change the defaults, it is as easy as changing `font-size` or `color` CSS values.
 */
@Component({
  tag: 'aha-loading-dots',
  styleUrl: 'aha-loading-dots.css',
  shadow: true,
})
export class AhaLoadingDots {
  @Element() host!: HTMLAhaLoadingDotsElement;

  private cleanupVisibilityObserver?: () => void;

  componentDidLoad() {
    this.cleanupVisibilityObserver = observeElementVisibility(this.host, isVisible => {
      if (isVisible) {
        this.host.classList.add('visible');
      } else {
        this.host.classList.remove('visible');
      }
    });
  }

  disconnectedCallback() {
    this.cleanupVisibilityObserver?.();
  }

  render() {
    return (
      <Host>
        <div id="dots">
          <div class="dot" id="dot-1"></div>
          <div class="dot" id="dot-2"></div>
          <div class="dot" id="dot-3"></div>
        </div>
      </Host>
    );
  }
}
